import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from "yup";
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FormField from '../layout/FormField';

const ForgotForm = () => {
  const validate = Yup.object({
    email: Yup.string().email("Invalid Email").required("Required"),
  })
    return (
        <div className="p-5 form_container mx-auto">
            <div className="heading mb-3 text-center">
                <h3>Forgot Password</h3>
            </div>
            <Formik
            initialValues={{
              email: "",
            }}
            validationSchema={validate}
            onSubmit={
              (values)=> {
                console.log("signin", values)
              }
            }
            >
                <Form>
                    <FormField label="Email Address" name="email" type="email" />                    
                    <div className="d-grid gap-2">
                        <Button type="submit" className="theme-btn mb-3">
                            Continue
                        </Button>
                        <Link to="/login" className="d-grid text-start text-dark">Back to Login</Link>
                    </div>
                </Form>
            </Formik>
        </div>
    );
};

export default ForgotForm;
